import { route, tag, type PageTour } from '../pageTour';

/** One tour for every AI model report. `/reports/heatmap` has its own tour and must be listed first. */
export const reportTour: PageTour = {
  id: 'page-report',
  version: 1,
  title: 'Reports',
  summary: 'Detections for an AI model, with charts, filters and export.',
  match: route('/reports/:model'),
  steps: [
    {
      target: tag('report-camera'),
      title: 'Pick a camera',
      description: 'Narrow the report to one camera, or pick a group above it to see a whole area. The search box at the top of this column finds events by text.',
      side: 'right',
    },
    {
      target: tag('report-date-range'),
      title: 'Date range',
      description: 'Set a start and end date to see only the events from that period.',
      side: 'right',
    },
    {
      target: tag('report-view'),
      title: 'Cards, table or chart',
      description: 'Switch between snapshot cards, a compact table and, where the report has one, a chart.',
      side: 'bottom',
    },
    {
      target: tag('report-results'),
      title: 'Events',
      description: 'Every event this model recorded for the selected site. Click one to open its full record with snapshots.',
      side: 'top',
    },
    {
      target: tag('report-registered-people'),
      title: 'Registered people',
      description: 'Manage the people the face recognition knows, and mark who is an employee.',
      side: 'bottom',
    },
    {
      target: tag('report-blacklist'),
      title: 'Blacklisted vehicles',
      description: 'Register the number plates you want flagged whenever they are read.',
      side: 'bottom',
    },
    {
      target: tag('report-refresh'),
      title: 'Refresh',
      description: 'Reload the report to pick up the newest events.',
      side: 'bottom',
    },
  ],
};
